const routes = {
  organizations: '/',
  volunteers: '/volunteers',
  login: '/login',
  organization: (id: number | ':id') => `/organization/${id}`,
  volunteer: (id: number | ':id') => `/volunteer/${id}`,
}

export default routes
